module.exports = __webpack_public_path__ + "static/media/feedback.d51bbe0f.svg";